import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { setupBalanceInterceptor } from './services/balanceInterceptor';

// REL-58: глобальный показ сообщения о недостатке средств на балансе (HTTP 402).
setupBalanceInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);